import { getLink } from '../../../utils/utils';

import author from './author';
const content = {
  esp: (
    `
    <div class="poem">
      <p class="mb-3 bold text-center">* * *</p>

      <p class="poem-block mb-3">
        Disŝiras la terglobon ŝtata lim’,<br/>
        Disigas homojn la lingvar’ abunda.<br/>
        El nekompreno iĝas honta tim’,<br/>
        Aroge regas la malam’ profunda.
      </p>

      <p class="poem-block mb-3">
        La antaŭbabilona Paradiz’<br/>
        Reveni povas, se ni nur deziros.<br/>
        Kaj preterpasos nin terura kriz’,<br/>
        Se ni al la frateco kune iros.
      </p>

      <p class="poem-block mb-3">
        Ligiĝas ĉiuj kontinentoj<br/>
        Per ĉen’ de l’ homoj laboremaj.<br/>
        Boncelas la eksperimentoj<br/>
        De esperantoj bonfaremaj.
      </p>

      <p class="poem-block mb-3">
        Similas al matematik’<br/>
        La lingv’, por ĉiu unusola.<br/>
        Ĝi kiel Sun’, sen artifik’,<br/>
        Al ĉiu estas benevola.
      </p>

      <p class="poem-block mb-3">
        Jam tempas limojn pereigi,<br/>
        Kaj kun la kant’ popolojn ligi!<br/>
        Kiel ĉielon la Atlantoj,<br/>
        Terglobon tenos Esperantoj!
      </p>
    </div>
    `
  )
}

const itemName = {
  esp: 'Disŝiras la terglobon ŝtata lim’'
}

const item = {
  itemlink: getLink(itemName.esp),
  esp:{
    itemName: itemName.esp,
    itemContent: content.esp,
    itemAuthor: author.esp
  }
}
export default item;